module.exports = __webpack_public_path__ + "media/images/report_areas/sign_here-cc56e84f32f677037b1942bccb622cf2.png";